module.exports = __webpack_public_path__ + "img/line_kaw.f7bb4553.png";